import { Document, Graph, Lightning, Shield } from "../components/icons";
import images from "../images";
import routes from "../routes";
import React from "react";

import { slugify } from "./slugify";

export const MAX_COUNT_MAIN_PAGE = 3;
export const MAX_COUNT_PROJECTS_PAGE = 9;
export const MAX_COUNT_NEWS_PAGE = 13;
export const MAX_LENGTH_ACCOUNT = 9;

export const initialLatitude = 57.626559;
export const initialLongitude = 39.893813;

export const clientsCenters = [
  {
    id: 1,
    email: "info@sever-invest.ru",
    phone: "+7(986)600-16-12 (круглосуточно)",
    address: ["г. Ярославль,", "ул. Батова 28/2"],
    openingHours: ["пн-пт: 09:00 - 18:00", "сб-вс: выходной"],
    coords: {
      lat: 57.695975,
      lng: 39.793238,
    },
    map: images.OfficeYar,
  },
  {
    id: 2,
    email: "info@sever-invest.ru",
    phone: "+7(986)600-16-11 (круглосуточно)",
    address: ["г. Тутаев,", "ул. В. Терешковой, 7Б"],
    openingHours: ["пн-пт: 09:00 - 18:00", "сб-вс: выходной"],
    coords: {
      lat: 57.857783,
      lng: 39.513269,
    },
    map: images.OfficeTutaev,
  },
  {
    id: 3,
    email: "info@sever-invest.ru",
    phone: "+7(986)600-16-10 (круглосуточно)",
    address: ["п. Константиновский,", "ул. Ленина, 10а"],
    openingHours: ["ежедневно: 00:00 - 24:00", "без выходных"],
    coords: {
      lat: 57.828687,
      lng: 39.594953,
    },
    map: images.OfficeKonst,
  },
];

export const companyLinks = [
  {
    text: "О нас",
    url: "#",
    id: "1",
  },
  {
    text: "Наши дома",
    url: "#",
    id: "2",
  },
  {
    text: "блог",
    url: "#",
    id: "3",
  },
  {
    text: "Проекты",
    url: "#",
    id: "4",
  },
  {
    text: "Контакты",
    url: "#",
    id: "5",
  },
  {
    text: "Вакансии",
    url: "#",
    id: "6",
  },
];

export const houseCards = [
  {
    id: 1,
    text: "Клиентский центр: г. Ярославль, ул. Батова 28/2; \n Телефон: +7(986)600-16-12 ",
    title: "Ярославль",
    image: images.OurHouses1,
    coords: {
      lat: 57.688441,
      lng: 39.795244,
    },
  },
  {
    id: 2,
    text: "Клиентский центр: г. Тутаев, ул. В. Терешковой, 7Б; \n Телефон: +7(986)600-16-11",
    title: "Тутаев",
    image: images.OurHouses2,
    coords: {
      lat: 57.86133,
      lng: 39.514699,
    },
  },
  {
    id: 3,
    text: "Клиентский центр: п. Константиновский, ул. Ленина, 10а; \n Телефон: +7(986)600-16-10 ",
    title: "Константиновское сельское поселение",
    image: images.OurHouses3,
    coords: {
      lat: 57.829521,
      lng: 39.586194,
    },
  },
];

export const aboutCompanyCards = [
  {
    id: 1,
    title: "Дата регистрации",
    text: "11 ноября 2002 года",
  },
  {
    id: 2,
    title: "Генеральный директор",
    text: "Васильев Анатолий Васильевич",
  },
  {
    id: 3,
    title: "Уставный капитал",
    text: "410 000 рублей",
  },
  {
    id: 4,
    title: "Основной вид деятельности",
    text: "Управление жилой недвижимостью",
  },
];

export const ourAdvantagesBlockCards = [
  {
    id: 1,
    title: "Профессионализм и опыт",
    text: "Наша команда — опытные специалисты в обслуживании многоквартирных домов. Многие работают с нами с самого основания — более 20 лет. Мы регулярно обучаем сотрудников и повышаем их квалификацию, чтобы сочетать опыт с современными знаниями. Это позволяет нам эффективно решать проблемы «возрастного» жилфонда и поддерживать комфорт в новых домах.",
    icon: <Graph />,
    image: images.HouseCard,
  },
  {
    id: 2,
    title: "Прозрачность и отчётность",
    text: "Мы ценим доверие жителей и стремимся к долгосрочному развитию. Поэтому обеспечиваем прозрачность и открытость работы. Вы всегда можете получить полную информацию о нашей деятельности: отчёты о финансово-хозяйственной деятельности, перечень услуг и утвержденные тарифы.",
    icon: <Document />,
    image: images.HouseCard,
  },
  {
    id: 3,
    title: "Техническая оснащенность",
    text: "Наша материально-техническая база полностью укомплектована: транспорт, техника, оборудование и инвентарь обеспечивают всестороннее обслуживание жилфонда. Собственная промышленная база и склад позволяют нам оперативно реагировать на задачи, сохраняя высокое качество услуг по конкурентным ценам.",
    icon: <Lightning />,
    image: images.HouseCard,
  },
  {
    id: 4,
    title: "Ответственность и гарантия",
    text: "Выбирая нашу управляющую компанию, жители получают гарантированное качество услуг. Мы несем ответственность за свои обязательства, подтверждая их гарантиями и другими надежными механизмами.",
    icon: <Shield />,
    image: images.HouseCard,
  },
];

export const menu = [
  {
    id: 1,
    title: "Главная",
    link: routes.home,
  },
  {
    id: 2,
    title: "О нас",
    link: routes.about,
  },
  {
    id: 3,
    title: "Наши дома",
    link: routes.houses,
  },
  {
    id: 4,
    title: "Новости",
    link: routes.blog,
  },
  // {
  //   id: 5,
  //   title: "Проекты и кейсы",
  //   link: routes.projects,
  // },
  {
    id: 6,
    title: "Контакты",
    link: routes.contacts,
  },
  {
    id: 7,
    title: "Оплатить",
    action: "openPaymentModal",
  },
  // {
  //   id: 8,
  //   title: "Оплата",
  //   link: routes.payment,
  // },
];

export const slides = [
  {
    id: 1,
    img: images.Partner1,
    alt: "Городская курьерская служба",
  },
  {
    id: 2,
    img: images.Partner2,
    alt: "ТНС-эрерго Ярославль",
  },
  {
    id: 3,
    img: images.Partner3,
    alt: "Безопасный регион",
  },
  {
    id: 4,
    img: images.Partner4,
    alt: "Ярославский водоканал",
  },
  {
    id: 5,
    img: images.Partner5,
    alt: "Газпром Газораспределение Ярославль",
  },
  {
    id: 6,
    img: images.Partner6,
    alt: "Мегафон",
  },
  {
    id: 7,
    img: images.Partner7,
    alt: "Платежный сервис А3",
  },
  {
    id: 8,
    img: images.Partner8,
    alt: "Ярославский ЦСМ",
  },
  {
    id: 9,
    img: images.Partner9,
    alt: "Городская курьерская служба",
  },
  {
    id: 10,
    img: images.Partner10,
    alt: "ТНС-эрерго Ярославль",
  },
  {
    id: 11,
    img: images.Partner11,
    alt: "Безопасный регион",
  },
  {
    id: 12,
    img: images.Partner12,
    alt: "Ярославский водоканал",
  },
  {
    id: 13,
    img: images.Partner13,
    alt: "Газпром Газораспределение Ярославль",
  },
  {
    id: 14,
    img: images.Partner14,
    alt: "Мегафон",
  },
  {
    id: 15,
    img: images.Partner15,
    alt: "Платежный сервис А3",
  },
  {
    id: 16,
    img: images.Partner16,
    alt: "Ярославский ЦСМ",
  },
];

export const ourTeam = [
  {
    id: 1,
    fullName: "Николай Васильев",
    position: "Владелец компании",
    photo: images.TeamPhoto1,
  },
  {
    id: 2,
    fullName: "Анатолий Васильев",
    position: "Генеральный директор",
    photo: images.TeamPhoto2,
  },
  {
    id: 3,
    fullName: "Ольга Теплякова",
    position: "Исполнительный директор",
    photo: images.TeamPhoto3,
  },
];

export const ourAwards = [
  {
    id: 1,
    title: "Почетная грамота",
    text: (
      <>
        {" "}
        За многолетний добросовестный труд и высокий профессионализм в сфере жилищно-коммунального хозяйства{" "}
        <b>Иванова Ирина Анатольевна</b>, заместитель начальника информационно-расчетного центра, удостоена Почетной
        грамоты Ярославской областной думы.
      </>
    ),
    image: images.award1,
  },
  {
    id: 2,
    title: "Почетная грамота",
    text: (
      <>
        Почётная грамота Ярославской областной Думы вручена <b>Тепляковой Ольге Евгеньевне </b>, исполнительному
        директору. За лидерство, поддержку команды и безупречную работу в непростых условиях.
      </>
    ),
    image: images.award2,
  },
  {
    id: 3,
    title: "Почётные грамоты",
    text: (
      <>
        — <b>Протасову Павлу Михайловичу</b>, главному инженеру <br />— <b>Шавандиной Валентине Дмитриевне</b>,
        начальнику отдела «Энергоконтроль»
        <br />— <b>Потапову Николаю Александровичу</b>, техническому директору <br />
        За системный подход, умение работать с людьми и весомый вклад в развитие инфраструктуры ЖКХ.
      </>
    ),
    image: images.award3,
  },
  {
    id: 4,
    title: "Благодарность",
    text: (
      <>
        Администрация Тутаевского муниципального района выражает благодарность Председателю совета директоров{" "}
        <b>Васильеву Николаю Васильевичу</b> и коллективу компании за участие в новогодней выставке «Арт-объект 2024» и
        вклад в создание праздничной атмосферы в городе.
      </>
    ),
    image: images.award4,
  },
  {
    id: 5,
    title: "Благодарственное письмо",
    text: (
      <>
        Начальнику отдела техников <b>Брыгиной Марии Юрьевне</b> вручено благодарственное письмо Главы Тутаевского
        муниципального района за значимый вклад в развитие и эффективное решение задач в сфере жилищно-коммунального
        хозяйства.
      </>
    ),
    image: images.award5,
  },
  {
    id: 6,
    title: "Почетная грамота",
    text: (
      <>
        Почётная грамота Главы Тутаевского муниципального района вручена начальнику юридического отдела{" "}
        <b>Ильиной Анастасии Сергеевне</b> за значительные трудовые и производственные достижения, а также за
        принципиальность и профессионализм
      </>
    ),
    image: images.award6,
  },
  {
    id: 7,
    title: "Благодарственное письмо",
    text: (
      <>
        Благодарственное письмо Главы Тутаевского муниципального района вручено бухгалтеру{" "}
        <b>Борисовой Татьяне Валерьевне</b> за значительные трудовые и производственные достижения, внимательное
        отношение к деталям и стабильность в работе.
      </>
    ),
    image: images.award7,
  },
];

export const dialogs = [
  {
    id: 1,
    client: {
      name: "Шутова Наталья Львовна",
      address: " п. Константиновский, ул. Свободы,  д. 13",
      avatar: images.Client1,
      desc: "Председатель Совета МКД",
      messages: [
        {
          id: 1,
          message:
            "Я недавно стала старшей по дому. На первых порах мне помогали специалисты: всё объясняли и вместе со мной выходили на дом для осмотров.",
        },
        {
          id: 2,
          message:
            "Теперь мы с техником и начальником участка планируем работы на год вперёд. Сначала рассчитываем стоимость, потом собираем материалы и выполняем работу.",
        },
        {
          id: 3,
          message: "Создали канал дома в Телеграме. Там — новости, отчёты и полезная информация. Очень удобно!",
        },
        {
          id: 4,
          message:
            "Наш дом не новый, бывают аварии. Диспетчеры и аварийная бригада работают отлично — быстро отвечают и приезжают.",
        },
        {
          id: 5,
          message:
            "Хочу поблагодарить коллектив «Север-Инвест». Всегда готовы помочь и всё объяснить — от техника до руководства. Спасибо!",
        },
      ],
    },
  },
  {
    id: 2,
    client: {
      name: "Завьялов Денис Викторович",
      address: "г. Ярославль, ул. Брагинская,  д. 18, корп. 1",
      avatar: images.Client2,
      desc: "Председатель Совета МКД",
      messages: [
        {
          id: 1,
          message: "При смене управляющей организации доверились положительным отзывам от соседей — и не пожалели.",
        },
        {
          id: 2,
          message: "Компания «Север-Инвест» работает на рынке ЖКХ уже более 20 лет. В обслуживании более 130 домов.",
        },
        {
          id: 3,
          message: "В компании — квалифицированные сотрудники и налажена обратная связь с жителями.",
        },
        {
          id: 4,
          message: "В компании оперативно реагируют на заявки, а Телеграмм-бот помогает в решении многих вопросов.",
        },
        {
          id: 5,
          message:
            "Заключены прямые договоры с ресурсоснабжающими организациями! Проводится корректная работа с должниками.",
        },
      ],
    },
  },
  {
    id: 3,
    client: {
      name: "Ефимова Татьяна Леонидовна",
      address: "п. Константиновский, ул. Ленина, д. 16",
      avatar: images.Client3,
      desc: "Председатель МКД",
      messages: [
        {
          id: 1,
          message:
            "Уже более пяти лет я руковожу нашим домом и могу с уверенностью сказать — у нас отличная управляющая компания!",
        },
        {
          id: 2,
          message: "Мы принимаем решения вместе с жителями, обсуждаем и контролируем работу УК.",
        },
        {
          id: 3,
          message: "В 2015 году сделали капитальный ремонт крыши, сейчас меняем стояки в квартирах.",
        },
        {
          id: 4,
          message:
            "Раньше вокруг дома была глина, без сапог не пройти. Благодаря УК и жителям добились благоустройства по программе «Решаем вместе».",
        },
        {
          id: 5,
          message: "Теперь у нас красиво и комфортно. Работы ещё много, но мы настроены продолжать!",
        },
      ],
    },
  },
  {
    id: 4,
    client: {
      name: "Ягодкина Светлана Владимировна",
      address: "п. Фоминское, ул. Центральная, д. 5",
      avatar: images.Client4,
      desc: "Инициативный житель МКД",
      messages: [
        {
          id: 1,
          message:
            "Наш дом — 1965 года постройки. Долгое время зимой в квартире было очень холодно, особенно с двумя маленькими детьми.",
        },
        {
          id: 2,
          message: "Обратились с просьбой утеплить квартиру — и нас включили в план работ.",
        },
        {
          id: 3,
          message: "Работы выполнили аккуратно, всё заделали, после себя убрали. Бригада сработала отлично!",
        },
        {
          id: 4,
          message: "Теперь в квартире по-настоящему тепло. В эту зиму мы входим спокойно, без страха за холодные полы.",
        },
      ],
    },
  },
  {
    id: 5,
    client: {
      name: "Чумагина Елена Владимировна",
      address: "г. Ярославль, ул. Панина, д. 3",
      avatar: images.Client5,
      desc: "Председатель МКД",
      messages: [
        {
          id: 1,
          message:
            "Я живу в своей новой квартире на Панина 3А уже три года и постоянно контактирую с компанией «Север-Инвест».",
        },
        {
          id: 2,
          message:
            "Специалисты компании — приятные и контактные, всегда на связи. Также есть чат в Телеграме и общий колл-центр, где удобно оставлять заявки по техническим вопросам.",
        },
        {
          id: 3,
          message:
            "Территория дома ухожена: летом трава подстрижена, зимой снег убирается трактором. Установлены декоративные заборчики на газонах.",
        },
        {
          id: 4,
          message:
            "Несмотря на удалённое расположение и случаи вандализма, УК оперативно устраняет последствия и усиливает меры безопасности.",
        },
        {
          id: 5,
          message:
            "Мы не пожалели, что выбрали «Север-Инвест». Спасибо сотрудникам за работу и внимательное отношение к жильцам!",
        },
      ],
    },
  },
  {
    id: 6,
    client: {
      name: "Орлова Галина Львовна",
      address: "г. Тутаев, ул.Ярославская, д.105",
      avatar: images.Client6,
      desc: "Председатель МКД",
      messages: [
        {
          id: 1,
          message:
            "Хочу выразить благодарность коллективу компании «Север-Инвест», который всегда остаётся на связи и оперативно реагирует, если требуется ремонт.",
        },
        {
          id: 2,
          message:
            "Год назад провели большую работу — восстановили фасад и цоколь. Получилось красиво, дом буквально расцвёл.",
        },
        {
          id: 5,
          message: "Дом небольшой, территория ухожена. Наш дворник следит за порядком — мы довольны его работой.",
        },
        {
          id: 6,
          message: "Техник Анна всегда на связи, быстро отвечает на звонки. Работать с ней — одно удовольствие.",
        },
        {
          id: 7,
          message: "Диспетчера и аварийная бригада всегда вежливы и внимательны к жителям.",
        },
        {
          id: 8,
          message:
            "Мы, жители дома 105 по улице Ярославской, очень довольны выбором управляющей компании «Север-Инвест».",
        },
      ],
    },
  },
];

export const ourHistory = [
  {
    id: 1,
    year: "2002",
    title: "Основание компании",
    text: "Компания начала свою деятельность в сфере строительства коммерческой недвижимости.",
  },
  {
    id: 2,
    year: "2004",
    title: "Изменение направления деятельности",
    text: "Компания взяла на обслуживание более 100 домов в поселке Константиновский, арендовав старую базу жилищно-эксплуатационного управления.",
  },
  {
    id: 3,
    year: "2005",
    title: "Вступление в силу Жилищного кодекса РФ",
    text: "С принятием нового Жилищного кодекса введено понятие «управление домом». Компания заключила первые договоры управления многоквартирными домами в поселке Фоминское.",
  },
  {
    id: 4,
    year: "2006",
    title: "Расширение компании",
    text: "Компания увеличила штат сотрудников и расширила материально-техническую базу.",
  },
  {
    id: 5,
    year: "2007",
    title: "Массовая замена инженерных сетей",
    text: "В многоквартирных домах проведена масштабная замена систем холодного и горячего водоснабжения, а также труб отопления. Старые железные трубы заменены на современные полипропиленовые. Сотрудники прошли переобучение на новые технологии.",
  },
  {
    id: 6,
    year: "2008",
    title: "Начало программы капитального ремонта",
    text: "В Ярославской области стартовали первые капитальные ремонты многоквартирных домов в рамках федерального закона 185-ФЗ «О Фонде содействия реформированию ЖКХ».",
  },
  {
    id: 7,
    year: "2009",
    title: "Расширение географии управления",
    text: "Компания заключила договоры на управление многоквартирными домами в городе Тутаев, расширяя свое присутствие в регионе.",
  },
  {
    id: 8,
    year: "2010",
    title: "Начало капитального ремонта домов",
    text: "Компания подключилась к реализации программы 185-ФЗ и капитально отремонтировала первые три дома.",
  },
  {
    id: 9,
    year: "2011",
    title: "Продолжение капитального ремонта и приобретение базы",
    text: "Компания провела капитальный ремонт 6 многоквартирных домов. В этом же году был приобретен в собственность производственно-офисный комплекс.",
  },
  {
    id: 10,
    year: "2013",
    title: "Завершение программы капитального ремонта по 185-ФЗ",
    text: "Это был последний год действия федерального закона 185-ФЗ «О Фонде содействия реформированию ЖКХ». За весь период его реализации с 2008 по 2013 год компания капитально отремонтировала 18 домов.",
  },
  {
    id: 11,
    year: "2014",
    title: "Лицензирование управляющих компаний",
    text: "Управляющие компании подлежат обязательному лицензированию. Север-Инвест получил лицензию после успешной сдачи экзаменов. В том же году вступил в силу закон №271-ФЗ, установивший формирование фонда капремонта за счёт взносов собственников.",
  },
  {
    id: 10,
    year: "2015",
    title: "Первые капитальные ремонты по новому законодательству",
    text: "Компания провела капитальные ремонты многоквартирных домов в соответствии с новым порядком.",
  },
  {
    id: 10,
    year: "2016",
    title: "Новое офисное здание",
    text: "Компания построила современный двухэтажный офис для сотрудников.",
  },
  {
    id: 10,
    year: "2017",
    title: "Создание отдела энергоконтроля",
    text: "Компания подключилась к проекту благоустройства территорий «Решаем вместе». К своему 15-летию компания благоустроила Сквер Счастья в Константиновском. Создала службу энергоконтроля и за несколько месяцев снизила потребление электроэнергии до норматива.",
  },
  {
    id: 9,
    year: "2019",
    title: "Разработка собственного ПО и расширение бизнеса",
    text: "Компания разработала собственное программное обеспечение для управления бизнес-процессами: CRM, планирование, таск-менеджер, бюджетирование. Север-Инвест открыл участок в северном жилом районе Ярославля, где жители 11 домов заключили договора управления с компанией.",
  },
  {
    id: 9,
    year: "2020",
    title: "Рост компании и модернизация инфраструктуры",
    text: "Штат сотрудников приблизился к 100 человекам. Проведен ремонт складских и производственных помещений, оборудованы душевые и раздевалки для рабочих.",
  },
  {
    id: 9,
    year: "2021",
    title: "Завершение программы «Решаем вместе»",
    text: "Завершена региональная программа «Решаем вместе». За период 2017–2021 годы компания совместно с местными и областными властями благоустроила 26 дворов.",
  },
  {
    id: 9,
    year: "2022",
    title: "Юбилей: компании 20 лет",
    text: "К 20-летию Север-Инвест организовал торжественное мероприятие во Дворце культуры, собрав полный зал сотрудников, включая ветеранов компании и тех, кто работал в разные годы.",
  },
  {
    id: 9,
    year: "2024",
    title: "Расширение клиентской базы",
    text: "Компания продолжает расти. К концу года 22 дома в Ярославле заключили договора управления с Север-Инвест. Всего же компания управляет и обслуживает 146 домами в 4-х населенных пунктах Ярославской области.",
  },
];

export const weDoing = [
  {
    id: 0,
    title: "Обслуживание домов",
    text: "Следим за исправностью инженерных систем и инфраструктуры, чтобы жильцы всегда чувствовали себя комфортно. Регулярно проводим обследование коммуникаций, своевременно устраняем неисправности и выполняем как текущий, так и капитальный ремонт. Обеспечиваем бесперебойную работу лифтов, отопления, водоснабжения и других жизненно важных систем.",
    image: images.WhatDoing1,
  },
  {
    id: 1,
    title: "Благоустройство",
    text: "Заботимся о чистоте и порядке на придомовой территории, создавая комфортное и безопасное пространство для жителей. Регулярно убираем дворы, следим за состоянием зеленых зон, детских и спортивных площадок. В теплое время года проводим озеленение, ухаживаем за растениями, а зимой оперативно убираем снег и наледь.",
    image: images.WhatDoing2,
  },
  {
    id: 2,
    title: "Работа с жителями",
    text: "Оперативно отвечаем на вопросы, принимаем заявки и предлагаем удобные способы связи с управляющей компанией. Делаем коммуникацию с жителями простой и понятной: заявки можно подать через телефон, телеграм-бота или электронную почту. Информируем о важных событиях, работах и изменениях, обеспечивая прозрачность и доступность информации.",
    image: images.WhatDoing3,
  },
  {
    id: 3,
    title: "Контроль и управление",
    text: "Контролируем выполнение работ, соблюдение сроков и эффективность процессов управления домами. Используем современные технологии и автоматизированные системы. Анализируем работу сотрудников и подрядчиков, повышая качество предоставляемых услуг и предотвращая возможные проблемы.",
    image: images.WhatDoing4,
  },
];

export const howWeWorkBlock1 = [
  {
    id: 1,
    title: "Оперативность и контроль",
    text: "Мы быстро реагируем на обращения жителей и контролируем выполнение каждой заявки. Используем цифровые инструменты, чтобы ничего не оставалось без внимания.",
  },
  {
    id: 2,
    title: "Прозрачность и открытость",
    text: "Жители всегда знают, на каком этапе их запрос. Вся информация о работах и начислениях доступна, а взаимодействие с управляющей компанией — простое и понятное.",
  },
];

export const howWeWorkBlock2 = [
  {
    id: 1,
    title: "Современные технологии",
    text: "Автоматизированные процессы позволяют нам работать эффективнее, снижать затраты и повышать качество услуг. Мы используем цифровые решения для удобства жителей и специалистов.",
  },
  {
    id: 2,
    title: "Профессиональная команда",
    text: "Наши специалисты — это опытные управленцы, инженеры и диспетчеры. Мы постоянно обучаем персонал и совершенствуем процессы, чтобы уровень сервиса оставался высоким.",
  },
];

export const repairWorks = [
  {
    id: 1,
    title: "Заголовок",
    slug: "repair-works-zagolovok",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.RepairBlock,
    imageHover: images.RepairBlock1,
    mainImage: images.ProjectsMain,
    images: [images.ProjectImages, images.ProjectImages1, images.ProjectImages2, images.ProjectImages3],
    date: "12.11.2024",
    category: "Ремонтные работы",
    company: "Север-Инвест",
    address: "Россия, город, улица, дом",
    work: "Исправление водоснабжения",
    works: [
      {
        id: 0,
        title: "H2 заголовок",
        text: [
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
        ],
      },
      {
        id: 1,
        title: "H2 заголовок",
        text: [
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
        ],
      },
    ],
  },
  {
    id: 2,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    //image: images.RepairBlock1,
    // mainImage: images.ProjectsMain,
    // images: [images.ProjectImages, images.ProjectImages1, images.ProjectImages2, images.ProjectImages3],
    date: "12.11.2024",
    category: "Ремонтные работы",
    company: "Север-Инвест",
    address: "Россия, город, улица, дом",
    work: "Исправление водоснабжения",
    works: [
      {
        id: 0,
        title: "H2 заголовок",
        text: [
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
        ],
      },
      // {
      //   id: 1,
      //   title: 'H2 заголовок',
      //   text: [`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
      //     `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
      //     Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
      //     `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`
      //   ]
      // }
    ],
  },
  {
    id: 3,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.RepairBlock2,
    mainImage: images.ProjectsMain,
    images: [images.ProjectImages, images.ProjectImages1, images.ProjectImages2, images.ProjectImages3],
    date: "12.11.2024",
    category: "Ремонтные работы",
    company: "Север-Инвест",
    address: "Россия, город, улица, дом",
    work: "Исправление водоснабжения",
    works: [
      {
        id: 0,
        title: "H2 заголовок",
        text: [
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
        ],
      },
      {
        id: 1,
        title: "H2 заголовок",
        text: [
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
        ],
      },
    ],
  },
  {
    id: 4,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.RepairBlock,
    mainImage: images.ProjectsMain,
    images: [images.ProjectImages, images.ProjectImages1, images.ProjectImages2, images.ProjectImages3],
    date: "12.11.2024",
    category: "Ремонтные работы",
    company: "Север-Инвест",
    address: "Россия, город, улица, дом",
    work: "Исправление водоснабжения",
    works: [
      {
        id: 0,
        title: "H2 заголовок",
        text: [
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
        ],
      },
      {
        id: 1,
        title: "H2 заголовок",
        text: [
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
        ],
      },
    ],
  },
  {
    id: 5,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.RepairBlock1,
    mainImage: images.ProjectsMain,
    images: [images.ProjectImages, images.ProjectImages1, images.ProjectImages2, images.ProjectImages3],
    date: "12.11.2024",
    category: "Ремонтные работы",
    company: "Север-Инвест",
    address: "Россия, город, улица, дом",
    work: "Исправление водоснабжения",
    works: [
      {
        id: 0,
        title: "H2 заголовок",
        text: [
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
        ],
      },
      {
        id: 1,
        title: "H2 заголовок",
        text: [
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
        ],
      },
    ],
  },
  {
    id: 6,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.RepairBlock2,
    mainImage: images.ProjectsMain,
    images: [images.ProjectImages, images.ProjectImages1, images.ProjectImages2, images.ProjectImages3],
    date: "12.11.2024",
    category: "Ремонтные работы",
    company: "Север-Инвест",
    address: "Россия, город, улица, дом",
    work: "Исправление водоснабжения",
    works: [
      {
        id: 0,
        title: "H2 заголовок",
        text: [
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
        ],
      },
      {
        id: 1,
        title: "H2 заголовок",
        text: [
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequatLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat`,
        ],
      },
    ],
  },
];

export const landScapingWorks = [
  {
    id: 100,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.LandBlock,
    imageHover: images.LandBlock1,
  },
  {
    id: 101,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.LandBlock1,
  },
  {
    id: 102,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.LandBlock2,
  },
  {
    id: 103,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.LandBlock,
  },
  {
    id: 104,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.LandBlock1,
  },
  {
    id: 105,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.LandBlock2,
  },
];

export const managingHouses = [
  {
    id: 200,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.ManageHousesBlock,
    imageHover: images.ManageHousesBlock1,
  },
  {
    id: 201,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.ManageHousesBlock1,
  },
  {
    id: 202,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.ManageHousesBlock2,
  },
  {
    id: 203,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.ManageHousesBlock,
  },
  {
    id: 204,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.ManageHousesBlock1,
  },
  {
    id: 205,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.ManageHousesBlock2,
  },
];

export const allProjects = [
  {
    id: 300,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects,
  },
  {
    id: 301,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    //image: images.allProjects1,
  },
  {
    id: 302,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects2,
  },
  {
    id: 303,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects3,
  },
  {
    id: 304,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects4,
  },
  {
    id: 305,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects5,
  },
  {
    id: 306,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects6,
  },
  {
    id: 307,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects7,
  },
  {
    id: 308,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects8,
  },
  {
    id: 309,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects,
  },
  {
    id: 310,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects1,
  },
  {
    id: 311,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects2,
  },
  {
    id: 312,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects3,
  },
  {
    id: 313,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects4,
  },
  {
    id: 314,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects5,
  },
  {
    id: 315,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects6,
  },
  {
    id: 316,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects7,
  },
  {
    id: 317,
    title: "Заголовок",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.allProjects8,
  },
];

export const projects = [
  {
    id: 400,
    title: "Заголовок крупного проекта",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.MainProject,
    imageHover: images.MainProject1,
  },
  {
    id: 401,
    title: "Заголовок крупного проекта",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    //image: images.MainProject1,
  },
  {
    id: 402,
    title: "Заголовок крупного проекта",
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    image: images.MainProject2,
  },
];

export const vacancies = [
  {
    id: 1,
    title: "Название вакансии",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    address: "Город, местоположение",
    tags: ["Фултайм", "В офисе", "Без опыта"],
    date: "03.11.2024",
    icon: images.VacancyIcon,
    views: "100",
  },
  {
    id: 2,
    title: "Название вакансии",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    address: "Город, местоположение",
    tags: ["Фултайм", "В офисе", "Без опыта"],
    date: "01.11.2024",
    icon: images.VacancyIcon1,
    views: "100",
  },
  {
    id: 3,
    title: "Название вакансии",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    address: "Город, местоположение",
    tags: ["Фултайм", "В офисе", "Без опыта"],
    date: "03.10.2024",
    icon: images.VacancyIcon2,
    views: "100",
  },
  {
    id: 4,
    title: "Название вакансии",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    address: "Город, местоположение",
    tags: ["Фултайм", "В офисе", "Без опыта"],
    date: "04.11.2024",
    icon: images.VacancyIcon,
    views: "100",
  },
  {
    id: 5,
    title: "Название вакансии",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    address: "Город, местоположение",
    tags: ["Фултайм", "В офисе", "Без опыта"],
    date: "03.09.2024",
    icon: images.VacancyIcon1,
    views: "100",
  },
  {
    id: 6,
    title: "Название вакансии",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    address: "Город, местоположение",
    tags: ["Фултайм", "В офисе", "Без опыта"],
    date: "06.11.2024",
    icon: images.VacancyIcon2,
    views: "100",
  },
];

export const allProjectsConcat = repairWorks.concat(managingHouses, landScapingWorks, allProjects, projects);

function injectSlug(data, detectPostfix) {
  let newSlug = data.slug || slugify(data.title);
  const postfix = detectPostfix(newSlug);
  if (postfix) {
    newSlug += postfix;
  }
  data.slug = newSlug;
}

function getNewSlug(arrayConcat) {
  const slugs = new Map();

  const detectPostfix = slug => {
    let count = slugs.get(slug) || 0;
    count += 1;
    slugs.set(slug, count);
    if (count === 1) {
      return null;
    }
    return `-${count}`;
  };

  for (const proj of arrayConcat) {
    injectSlug(proj, detectPostfix);
  }
}

getNewSlug(allProjectsConcat);

export const allProjectsObj = allProjectsConcat.reduce((acc, project) => {
  acc[project.slug] = project;
  return acc;
}, {});

export const companyDetails = [
  {
    label: "Полное наименование",
    lines: ['Акционерное общество "Строительно-холдинговая компания "Север-Инвест"'],
  },
  {
    label: "ИНН/КПП/ОГРН",
    lines: ["ИНН: 7602037674", "КПП: 760201001", "ОГРН: 1027600512169"],
  },
  {
    label: "Юридический адрес",
    lines: ["Ярославль, Ленинградский проспект, д. 103, 2"],
  },
  {
    label: "Банковские реквизиты",
    lines: [
      "Расчетный счет: 40702810577030160387",
      "Банк: КАЛУЖСКОЕ ОТДЕЛЕНИЕ N8608 ПАО СБЕРБАНК",
      "БИК: 042908612",
      "Корр. счет: 30101810100000000612",
    ],
  },
];

export const contactsMax = [
  {
    title: "Официальный канал компании",
    subtitle: "Общие новости и жизнь компании",
    text: [
      "Публичный канал — это общее информационное пространство для всех жителей.",
      "Здесь мы публикуем новости компании, рассказываем об изменениях в работе и делимся событиями, которые важны для всех домов.",
      "Мы показываем, как развивается компания, делимся практическим опытом и реализованными инициативами. Рассказываем о подходах к работе и о том, какие решения помогают повышать качество обслуживания.",
      "Отдельно рассказываем об изменениях в законодательстве в сфере управления жилой недвижимостью — и о том, как это влияет на жизнь вашего дома и вас как жителя.",
    ],
    image1: images.ContactsLogoSi,
    image2: images.ContactsQrSi,
  },
  {
    title: "Макс-бот",
    subtitle: "Заявки, вопросы и контроль статуса",
    text: [
      "Макс-бот — основной канал связи с управляющей компанией.",
      "После первого обращения бот идентифицирует вас как жителя, регистрирует в системе Twayli и подключает к приватному каналу вашего дома.",
      "Через бота можно отправить заявку, задать вопрос, оставить жалобу или предложение. Каждое обращение фиксируется как тикет — единая карточка, в которой ведётся вся работа по вашему вопросу.",
      "Такой формат позволяет обрабатывать любые обращения одинаково чётко — от бытовых задач до официальных заявлений. В любой момент вы можете посмотреть статус и историю своих тикетов.",
    ],
    image1: images.ContactsLogoBot,
    image2: images.ContactsQrBot,
  },
  {
    title: "Приватные каналы домов",
    subtitle: "Работы, отчёты и прозрачность",
    text: [
      "Для каждого дома создаётся отдельный приватный канал.",
      "В нём публикуются все работы и события, которые относятся именно к вашему дому.",
      "Каждая задача — это отдельный пост с фотографиями, комментариями и пояснениями. Комментарии жителей и сотрудников автоматически сохраняются в системе Twayli и сразу попадают в работу специалистам.",
      "Канал — это не только информирование, но и инструмент контроля. Руководство и специалисты видят ход, объём и результат работ, а жители получают прозрачную информацию без дополнительных обращений.",
    ],
    image1: images.ContactsHouse1,
    image2: images.ContactsHouse2,
  },
];
